import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import {Field, reduxForm, formValueSelector, change} from 'redux-form';
import _get from "lodash/get";
import _isEmpty from 'lodash/isEmpty';
import {getLangCode, stringBundle} from '../../stringBundle';
import utils from '../../helpers/utils';
import Dropdown from '../common/Dropdown';

/*eslint-disable no-unused-vars*/
export const OPT_OUT='OptOut';

class EditIVRPrefForm extends Component {

  constructor(props) {
    super(props);
    const {error, initialize, handleSubmit, pristine, submitting, onSubmit} = props;
    let prefill = {};
    this.localizedStringBundle = stringBundle(getLangCode());
    this.renderDisclaimer = this.renderDisclaimer.bind(this);
    this.preloadData(this.props.propPreferences);
    this.state = {
      ivr: this.getSelectedOption(this.props.propPreferences) || '',
    };
  }

  componentDidMount() {
    this.props.initialize(this.prefill);
  }

  preloadData(inputPrefData) {
    const prefOptIn = _get(inputPrefData, 'voice.optIn');
    const prefNumber = _get(inputPrefData, 'voice.value');
    let prefs = {
      ivr: (prefOptIn === true) ? prefNumber : this.localizedStringBundle.MANAGE_ACCOUNT_OPT_OUT
    }
    this.prefill = Object.assign({}, prefs);
  }

  handleChange() {
    utils.trackEventForManageAccount('Contact_Call', this.localizedStringBundle.MANAGE_ACCOUNT_EDIT, true);
  }

  getSelectedOption(inputPrefData) {
    const prefOptIn = _get(inputPrefData, 'voice.optIn');
    const prefNumber = _get(inputPrefData, 'voice.value');
    return (prefOptIn === true) ? utils.formatPhone(prefNumber) : this.localizedStringBundle.DO_NOT_CALL
  }

  handleAlertPrefSelection(fieldName, object) {
    this.props.dispatch(change('editcontactivrpref', fieldName, object.value));
    this.setState(() => ({ivr: object.name}));
  }

  renderDropDown(inputData) {
    const contactPhone = _get(inputData, 'voice.value');
    let dropdownList = [
      {name: this.localizedStringBundle.DO_NOT_CALL, value: OPT_OUT},
      {name: utils.formatPhone(contactPhone), value: contactPhone},
    ];
    const selectedState = this.state.ivr ? {name: this.state.ivr} : {name: this.localizedStringBundle.DO_NOT_CALL};
    return (
      <div className="w-full">
      <Field name="ivr" id="ivr" component="select" className="hidden h-8 w-64 browser-default" onChange={this.handleChange}>
      </Field>
        <Dropdown selectClasses="test-alert-pref-ivr leading-normal h-8 w-64 border-1 border-grey-lighter outline-none" selectedName={selectedState} list={dropdownList}
                  setSelected={this.handleAlertPrefSelection.bind(this, 'ivr')}
                  optionClasses="shadow-md overflow-scroll"/>
      </div>
    );
  }

  renderUpdate() {
    return (
      <div className="mt-3 text-left">
        <button id="btn-ivr-update" className="btn h-8 w-22.5 text-black bg-yellow hover:bg-yellow-dark border-1 border-yellow" type="submit">{this.localizedStringBundle.UPDATE}</button>
      </div>
    )
  }

  renderDisclaimer() {
    if (this.props.ivrNumber === OPT_OUT) {
      return this.renderUpdate();
    }
    return (
       <div className="flex flex-wrap">
         <div className="mt-2 p-3 border-solid border-1 border-black-dark bg-grey-superlight">
            <div id="ivrDisclaimer" className="text-justify text-xs text-black"> {this.localizedStringBundle.MANAGE_ACCOUNT_DISCLAIMER_IVR} </div>
         </div>
         {this.renderUpdate()}
       </div>
    );
  }

  render() {
    if (_isEmpty(this.props.propPreferences)) {
      return null;
    }
    return (
      <form method="post" id="editIvrPrefForm" onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
      <div className="border-b border-grey-lighter pt-4 pb-5">
        <div className="text-base text-black pb-1">
            {this.localizedStringBundle.MANAGE_AP_CONTACT_IVR}
        </div>
        <div className="text-grey text-sm pb-2">
          {this.localizedStringBundle.MANAGE_AP_CONTACT_IVR_TEXT}
        </div>
         <div className="">
           {this.renderDropDown(this.props.propPreferences)}
         </div>
         {this.props.pristine ? '' : this.renderDisclaimer()}
      </div>
      </form>
    )
  }

}

EditIVRPrefForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.object,
  initialize: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  propPreferences: PropTypes.object,
  ivrNumber: PropTypes.string
};

const FORM_NAME = 'editcontactivrpref';


const selector = formValueSelector(FORM_NAME);
const reduxEditIVRPrefForm = connect(state => {
  const ivrNumber = selector(state, 'ivr');
  return {
    ivrNumber
  }

})(EditIVRPrefForm);

export default reduxForm({
  form: FORM_NAME
})(reduxEditIVRPrefForm);

/*eslint-enable no-unused-vars*/



// WEBPACK FOOTER //
// ./src/containers/monitoring/EditIVRPrefForm.js